/**
 * shared/src/schemas/publicEvents.schema.ts
 *
 * Contratto dell'endpoint PUBBLICO degli eventi (GET /api/events/public).
 *
 * Perché esiste (28 Ott 2026, punto 6): la pagina /events pubblica deve
 * poter validare la risposta del server senza duplicare un'interfaccia.
 * Questo schema è la FONTE UNICA: il client deriva il tipo con `z.infer`,
 * il server può usarlo nei test di contratto. Espone solo campi pubblici
 * (niente creator, meeting_point, coordinate o dati personali).
 */
import { z } from "zod";
export const PublicEventSchema = z.object({
    id: z.string(),
    title: z.string(),
    event_date: z.string(),
    end_datetime: z.string().nullable().optional(),
    province: z.string().nullable().optional(),
    bike_type: z.string().nullable().optional(),
    cover_image_url: z.string().nullable().optional(),
    status: z.string().nullable().optional(),
    chapter_name: z.string().nullable().optional(),
    is_past: z.boolean().nullable().optional(),
    participants_count: z.number().nullable().optional(),
});
export const PublicEventsResponseSchema = z.object({
    events: z.array(PublicEventSchema),
    count: z.number(),
});
//# sourceMappingURL=publicEvents.schema.js.map